import { createStore } from "vuex"
import warning from "./modules/warning"
import autocall from "./modules/autocall"
import complete from "./modules/complete"
import callgate from "./modules/callgate"
import useinfo from "./modules/useinfo"

export default createStore({
  modules: {
    warning,
    autocall,
    complete,
    callgate,
    useinfo,
  },
})
